var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaravan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 90V84C99.7575 84 102 81.7575 102 79V57C102 45.42 92.58 36 81 36H27C22.0375 36 18 40.0375 18 45V81C18 82.655 19.345 84 21 84H57V90H21C16.0375 90 12 85.9625 12 81V45C12 36.73 18.73 30 27 30H81C95.8875 30 108 42.1125 108 57V79C108 85.065 103.065 90 97 90Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 84H81V90H114V84Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7525 87H26.7525V52C26.7525 48.14 29.8925 45 33.7525 45H43.7525C47.6125 45 50.7525 48.14 50.7525 52V63H44.7525V52C44.7525 51.4475 44.305 51 43.7525 51H33.7525C33.2 51 32.7525 51.4475 32.7525 52V87Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7525 87H44.7525V72H41.7525V66H47.7525L50.7525 69V87Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66H79C75.14 66 72 62.86 72 59V52C72 48.14 75.14 45 79 45H86C89.86 45 93 48.14 93 52V59C93 62.86 89.86 66 86 66ZM79 51C78.4475 51 78 51.4475 78 52V59C78 59.5525 78.4475 60 79 60H86C86.5525 60 87 59.5525 87 59V52C87 51.4475 86.5525 51 86 51H79Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97.5C60.21 97.5 55.5 92.79 55.5 87C55.5 81.21 60.21 76.5 66 76.5C68.805 76.5 71.4425 77.5925 73.425 79.575C75.4075 81.5575 76.5 84.195 76.5 87C76.5 92.79 71.79 97.5 66 97.5ZM66 82.5C63.52 82.5 61.5 84.5175 61.5 87C61.5 89.4825 63.5175 91.5 66 91.5C68.4825 91.5 70.5 89.4825 70.5 87C70.5 85.7975 70.0325 84.6675 69.1825 83.8175C68.3325 82.9675 67.2025 82.5 66 82.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87H81C81 78.73 74.27 72 66 72H57V66H66C77.58 66 87 75.42 87 87Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaravan);
export default __webpack_public_path__ + "static/media/Caravan.0a480b08.svg";
export { ForwardRef as ReactComponent };